module.exports = __webpack_public_path__ + "static/Coinsuper-4c04fcb93acebcf52638cb55b5ce031f.png";